import { handleExportClick } from '../../ConsolidatedLogs/ConsolidatedController';
import { toPng } from "html-to-image";

export const exportSvgNodeAsPng = async (
  svgEl: SVGElement,
  filename: string,
  pixelRatio = 2
) => {
  const dataUrl = await toPng(svgEl as any, {
    pixelRatio,
    backgroundColor: "#fff",
  });
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename;
  a.click();
};

const exportSvgById = (svgId: string, filename: string) => {
  const svgEl = document.getElementById(svgId) as unknown as SVGElement | null;
  if (!svgEl) return console.error("Export failed: SVG not found:", svgId);

  const clone = svgEl.cloneNode(true) as SVGElement;
  clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  const svgText = new XMLSerializer().serializeToString(clone);

  const blob = new Blob([svgText], { type: "image/svg+xml;charset=utf-8" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

const exportRowsAsCsv = (rows: Record<string, any>[], filename: string) => {
  if (!rows || rows.length === 0) return;

  const headers = Object.keys(rows[0]);
  const escape = (v: any) => {
    const s = v === null || v === undefined ? "" : String(v);
    if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
  };

  const csv = [
    headers.join(","),
    ...rows.map((r) => headers.map((h) => escape(r[h])).join(",")),
  ].join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const runExport = async (

  sel: {
    mode: "graph" | "graph+data";
    format: "svg" | "png";
    pngScale: 1 | 2 | 3;
    dataFormat: "csv" | "xlsx";
  },
  args: {
    baseName?: string;
    exportSvgId: string;     // ✅ IMPORTANT: actual SVG element id
    exportRows?: any[];
  }
) => {
  if (typeof document === "undefined") return;

  const baseName = (args.baseName?.trim() || "Chart")
    .replace(/[\\/:*?"<>|]+/g, "-")
    .trim();

  const root = document.getElementById(args.exportSvgId);
  if (!root) {
    console.error("Export failed: element not found:", args.exportSvgId);
    return;
  }
  // ✅ if the id is on a wrapper (VictoryContainer), find the svg inside it
  const svgEl =
    root instanceof SVGElement ? root : (root.querySelector("svg") as SVGElement | null);

  if (!svgEl) {
    console.error("Export failed: <svg> not found under:", args.exportSvgId);
    return;
  }

  if (sel.format === "svg") {
    exportSvgById(args.exportSvgId, `${baseName}.svg`);
  } else {
    await exportSvgNodeAsPng(svgEl, `${baseName}.png`, sel.pngScale);
  }

  if (sel.mode === "graph+data") {
    const rows = args.exportRows ?? [];
    if (rows.length > 0) {
      if (sel.dataFormat === "csv") exportRowsAsCsv(rows, `${baseName}_Data.csv`);
      else handleExportClick(rows, `${baseName}_Data.xlsx`);
    } else {
      console.warn("No supporting data available to export.");
    }
  }
};


